export enum AppSettingsTypeEnum {
  APPLICATION_VERSION = "application_version",
  PRIVACY_POLICY = "privacy_policy",
  TERMS_OF_SERVICE = "terms_of_service",
  NOTICE_EXAM = "notice_exam",
  HOMEWORK_ALERT = "homework_alert",
  OLYMPIC_MESSAGE = "olympic_message",
  OLYMPIC_PRIZE_1 = "olympic_price_1",
  OLYMPIC_PRIZE_2 = "olympic_price_2",
  OLYMPIC_PRIZE_3 = "olympic_price_3",
  OLYMPIC_PRIZE_4 = "olympic_price_4",
  OLYMPIC_PRIZE_5 = "olympic_price_5",
  PURCHASE_SINGLE_SUBJECT_DESCRIPTION = "purchase_single_subject_description",
  PURCHASE_SINGLE_SUBJECT_DISPLAY_PRICE = "purchase_single_subject_display_price",
  PURCHASE_SINGLE_SUBJECTS_CHARGEABLE_PRICE = "purchase_single_subjects_chargeable_price",
  PURCHASE_ALL_SUBJECTS_DESCRIPTION = "purchase_all_subjects_description",
  PURCHASE_ALL_SUBJECTS_DISPLAY_PRICE = "purchase_all_subjects_display_price",
  PURCHASE_ALL_SUBJECTS_CHARGEABLE_PRICE = "purchase_all_subjects_chargeable_price",
}
